<template>
  <div>
    <div class="title title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">基本信息</div>
      </div>
      <div>
        <span>采购计划单号：</span>
        <span>{{ parseStrEmpty(formData.bizNo) }}</span>
      </div>
    </div>
    <el-form :model="formData" ref="form">
      <el-row :gutter="20">
        <el-col :span="12" :xs="12">
          <span class="line">
            计划名称：
            <span>{{parseStrEmpty(formData.name)}}</span>
          </span>
        </el-col>
        <el-col :span="12" :xs="12">
          <span class="line">
            客户名称：
            <span>{{parseStrEmpty(formData.customerName)}}</span>
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :xs="24">
          <span class="line">
            备注：
            <span>{{parseStrEmpty(formData.remark)}}</span>
          </span>
        </el-col>
      </el-row>
    </el-form>
    <div class="title title-mt">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">计划信息</div>
      </div>
    </div>

    <div class="topmargin">
      <TablePublic :colLists="colLists" :tableData="formData.itemRespList" :paginationFlag="false">
        <template slot="percentage" slot-scope="scope">
          <div class="progress">
            <el-progress
              color="#c59429"
              :stroke-width="10"
              type="circle"
              :percentage="scope.data.percentage"
            ></el-progress>
          </div>
        </template>
      </TablePublic>
    </div>

    <div class="title title-mt title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">附件信息</div>
      </div>
    </div>

    <Attachment
      v-if="fileData && fileData.length > 0"
      :fileList="fileData"
      :is-examine="true"
      :isEdit="false"
      :showFileType="false"
    ></Attachment>
    <div v-else class="no-contract-type">暂无内容</div>

    <div class="title title-mt title-mb">
      <div class="title-block">
        <div class="block"></div>
        <div class="titleText">历史修改记录</div>
      </div>
    </div>
    <TablePublic
      :colLists="colLists2"
      :tableData="tableData"
      tableHeight="400"
      :paginationFlag="false"
    >
      <template slot="modificationDesc" slot-scope="scope">
        <el-tooltip
          :disabled="!scope.data.modificationDesc"
          :content="scope.data.modificationDesc"
          placement="top"
          popper-class="custom-tooltip-width"
        >
          <div class="modificationDesc">{{ scope.data.modificationDesc }}</div>
        </el-tooltip>
        <el-popover placement="right-end" width="900" trigger="manual" v-model="scope.data.visible">
          <div>
            <div class="popover_title">
              <div>计划信息修改详情</div>
              <div class="el-icon-circle-close" @click="scope.data.visible = false"></div>
            </div>
            <div class="popover_over">
              <TablePublic
                :colLists="colLists4"
                :showIndex="false"
                :tableData="scope.data.lastList"
                :paginationFlag="false"
              ></TablePublic>
              <TablePublic
                style="margin-top: 20px;"
                :colLists="colLists3"
                :showIndex="false"
                :tableData="scope.data.beforeList"
                :paginationFlag="false"
              ></TablePublic>
            </div>
          </div>
          <div slot="reference" @click="scope.data.visible = true" style="width: 150px;">
            <span>“计划信息"修改</span>
            <span class="view_button"><详情></span>
          </div>
        </el-popover>
      </template>
    </TablePublic>
    <Box :row="formData"></Box>
  </div>
</template>

<script>
import { getPurchasePlanDetail, getAmdRecList } from '@/api/system/manage'
import TablePublic from '@/components/tablePublic'
import Attachment from '@/components/attachment.vue'
import Box from '@/components/nameBox.vue'
export default {
  components: {
    TablePublic,
    Attachment,
    Box,
  },
  data() {
    return {
      colLists4: [
        {
          prop: 'code',
          label: '修改后',
          isTrue: true,
          children: [],
        },
      ],
      colLists3: [
        {
          prop: 'code',
          label: '修改前',
          isTrue: true,
          children: [],
        },
      ],
      popoverChildren: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          width: '55',
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'ripenessLevelSpecValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'planToPurchaseNetWeight',
          label: '计划采购总净重(斤)',
          isTrue: true,
        },
      ],
      colLists2: [
        {
          prop: 'modificationDesc',
          label: '修改内容',
          isTrue: true,
          align: 'left',
          formSolt: true,
        },
        {
          prop: 'reason',
          label: '修改原因',
          align: 'left',
          isTrue: true,
        },
        {
          prop: 'createDate',
          label: '修改日期',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'createBy',
          label: '修改人',
          isTrue: true,
          width: '100',
        },
      ],
      colLists: [
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'ripenessLevelSpecValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'planToPurchaseNetWeight',
          label: '计划采购总净重(斤)',
          isTrue: true,
        },
        {
          prop: 'purchasedNetWeight',
          label: '已计划采摘总净重(斤)',
          isTrue: true,
        },
        {
          prop: 'percentage',
          label: '规划进度',
          isTrue: true,
          formSolt: true,
        },
      ],
      fileData: [],
      tableData: [],
      formData: {
        itemRespList: [],
        attachmentRespList: [],
      },
    }
  },
  methods: {
    getDetails(row) {
      if (row) {
        getPurchasePlanDetail(row.id).then((res) => {
          if (res.flag) {
            this.fileData =
              (res.data.attachmentRespList &&
                res.data.attachmentRespList.map((f) => {
                  return {
                    ...f,
                    fileUrl: f.url,
                    fileName: f.name,
                    fileType: f.type,
                    fileSuffix: f.name.substring(f.name.lastIndexOf('.') + 1),
                  }
                })) ||
              []
            this.formData = {
              ...res.data,
              customerName: res.data.list.map(d => d.customerName).join(','),
              itemRespList: res.data.itemRespList.map((d) => {
                d.percentage = this.myFixed((d.purchasedNetWeight / d.planToPurchaseNetWeight) * 100, 2)
                return d
              }),
            }
            this.colLists3[0].children = this.popoverChildren
            this.colLists4[0].children = this.popoverChildren
            this.getAmdRecList(row.id)
          }
        })
      }
    },
    getAmdRecList(id) {
      getAmdRecList({ formId: id, formType: 'purchase_plan' }).then((res) => {
        if (res.flag) {
          this.tableData = res.data.map((d) => {
            d.lastList = this.formatCropJsonParse(d.currContent)
            d.beforeList = this.formatCropJsonParse(d.orignalContent)
            d.createDate = this.parseTime(d.createTime, '{y}-{m}-{d}')
            d.visible = false
            return d
          })
        }
      })
    },
    reset() {
      this.tableData.some((item) => (item.visible = false))
    },
    cancel() {
      this.dialogVisible = false
    },
    formatCropJsonParse(obj) {
      if (!obj) {
        return []
      }
      let cropObj = JSON.parse(obj)
      let itemReqList = []
      if (cropObj.itemReqList && cropObj.itemReqList.length) {
        itemReqList = cropObj.itemReqList.map((d, index) => {
          d.index = index + 1
          d.code = cropObj.bizNo
          return d
        })
      } else if (cropObj.itemRespList && cropObj.itemRespList.length) {
        itemReqList = cropObj.itemRespList.map((d, index) => {
          d.index = index + 1
          d.code = cropObj.bizNo
          return d
        })
      }
      return itemReqList
    },
  },
}
</script>

<style scoped lang='less'>
@import '../../../../assets/form.less';
.progress {
  height: 48px;
}
.mt {
  margin-top: 20px;
}
/deep/ .el-form-item {
  margin-bottom: 0px;
}
.err {
  color: red;
  margin-left: 10px;
  font-size: 14px;
}
.topmargin {
  margin-top: 20px;
}
.line {
  display: flex;
  word-break: keep-all;
  padding: 8px 0;
  span{
    word-break: break-all;
  }
}
::v-deep {
  .no-contract-type {
    padding: 30px;
    background-color: #f8f8f8;
    border-radius: 12px;
    text-align: center;
    border: 1px solid #dde4ff;
    margin-top: 10px;
  }
}
</style>